var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.647.176a59.647 59.647 0 1 0 .706 0h-.706Zm0 30.353a26.823 26.823 0 1 1-.706 0h.706Zm-39.53 70.765c6.354-8.235 14.236-12.353 23.648-12.353h32.47c9.412 0 17.294 4.118 23.647 12.353a57.882 57.882 0 0 1-79.764 0Z",
    fill: "#E0E0E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderAvatar);
export default __webpack_public_path__ + "static/media/placeholder-avatar.a5762a0bde5ee77856c905f6adbb0195.svg";
export { ForwardRef as ReactComponent };